export default (state = {
    values: [],
    props: [],
}, action) => {
    switch (action.type) {
        case 'WIZARD_PRODUCT_ATTRIBUTES_SET_FORM_VALUES' :
            return {
                ...state,
                values: action.results.values,
                props: action.results.props,
            };

        default:
            return state;
    }
};
